import { MileageEntries } from '../models/mileage.model';

export interface MileageState {
  data: MileageEntries | null;
  loading: boolean;
  error: string | null;
}

export const initialState: MileageState = {
  data: null,
  loading: false,
  error: null,
};
